// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* tooltip */\n.mentor-tooltip {\n    max-width: 100%;\n}\n.mentor-tooltip .p-tooltip-text {\n    word-break: keep-all;\n    display: flex;\n    flex-direction: column;\n}\n\ntable.table-bordered .report-list-group .label-num-cell.cell-link a {\n    text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
